<template>
	<div>
		<svg width="44px" height="44px" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<g id="Globe" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g>
					<polygon id="Path" points="0 0 44 0 44 44 0 44"></polygon>
					<path d="M22,0 C9.856,0 0,9.856 0,22 C0,34.144 9.856,44 22,44 C34.144,44 44,34.144 44,22 C44,9.856 34.144,0 22,0 Z M19.8,39.446 C11.11,38.368 4.4,30.976 4.4,22 C4.4,20.636 4.576,19.338 4.862,18.062 L15.4,28.6 L15.4,30.8 C15.4,33.22 17.38,35.2 19.8,35.2 L19.8,39.446 Z M34.98,33.858 C34.408,32.076 32.78,30.8 30.8,30.8 L28.6,30.8 L28.6,24.2 C28.6,22.99 27.61,22 26.4,22 L13.2,22 L13.2,17.6 L17.6,17.6 C18.81,17.6 19.8,16.61 19.8,15.4 L19.8,11 L24.2,11 C26.62,11 28.6,9.02 28.6,6.6 L28.6,5.698 C35.046,8.316 39.6,14.63 39.6,22 C39.6,26.576 37.84,30.734 34.98,33.858 Z" id="Shape" :fill="color" fill-rule="nonzero"></path>
				</g>
			</g>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgBank',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
	},
};
</script>

<style scoped>

</style>